export const getOrgContext = () => {
  try {
    const raw = localStorage.getItem('rentual_org');
    return raw ? JSON.parse(raw) : null;
  } catch { return null; }
};

export const setOrgContext = (org) => {
  if (org) {
    localStorage.setItem('rentual_org', JSON.stringify(org));
  } else {
    localStorage.removeItem('rentual_org');
  }
};

export const clearOrgContext = () => localStorage.removeItem('rentual_org');

export const getOrgHeaders = () => {
  const org = getOrgContext();
  return org ? { 'X-Organization-Id': String(org.organizationId) } : {};
};
